import React, { SVGProps } from 'react';

export function EyeconSVG(props: SVGProps<SVGSVGElement>) {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <g opacity="0.4">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M23.6218 12C22.2897 6.82432 17.5914 3 11.9999 3C6.40836 3 1.71006 6.82432 0.37793 12C1.71006 17.1757 6.40836 21 11.9999 21C17.5914 21 22.2897 17.1757 23.6218 12ZM2.45711 12C3.7312 16.0581 7.52431 19 11.9999 19C16.4754 19 20.2686 16.0581 21.5426 12C20.2686 7.94186 16.4754 5 11.9999 5C7.52431 5 3.7312 7.94186 2.45711 12ZM11.9999 16C14.209 16 15.9999 14.2091 15.9999 12C15.9999 9.79086 14.209 8 11.9999 8C9.79074 8 7.99988 9.79086 7.99988 12C7.99988 14.2091 9.79074 16 11.9999 16ZM11.9999 14C13.1044 14 13.9999 13.1046 13.9999 12C13.9999 10.8954 13.1044 10 11.9999 10C10.8953 10 9.99988 10.8954 9.99988 12C9.99988 13.1046 10.8953 14 11.9999 14Z"
                    fill="current"
                />
            </g>
        </svg>
    );
}
